export default __webpack_public_path__ + "static/layout-anatomy-dark-393a516052313e5c50ef0ad6d4195ad0.png";